import { Truck } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Label } from '@/components/ui/label';
import { SimpleMultiSelect, type SelectOption } from '@/shared/ui/filters';

interface VehicleCategoryFilterProps {
  options: SelectOption[];
  value: string[];
  onChange: (value: string[]) => void;
  className?: string;
  isLoading?: boolean;
}

export function VehicleCategoryFilter({
  options,
  value,
  onChange,
  className = 'w-full md:w-80',
  isLoading = false
}: VehicleCategoryFilterProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-2">
      <Label className="text-sm font-medium flex items-center gap-2">
        <Truck className="h-4 w-4" />
        {t('dashboard.vehicleCategory.label', 'Vehicle Category')}
        <span className="text-xs text-muted-foreground">
          {t('dashboard.vehicleCategory.hint', '(only for internal transfers)')}
        </span>
      </Label>
      <SimpleMultiSelect
        options={options}
        value={value}
        onChange={onChange}
        placeholder={t('dashboard.vehicleCategory.placeholder', 'Select vehicle categories')}
        className={className}
      />
    </div>
  );
}
